<template>
  <div class="home-wrapper" id="home-wrapper">
    <!-- 活动标题 -->
    <div v-wechat-title="'三丽鸥联动-pc'">
      <div class="logo"></div>
      <div class="copyright"></div>
    </div>
  </div>
</template>
<script>
import { getTimeStamp } from "@/utils/utils";

export default {
  components: {},
  data() {
    return {
      gameName: "sakura",
    };
  },
  created() {
    if (this.isMobile()) {
      window.location.href = `https://h5.qingcigame.com/sakura/sanliouLinkage/enter${getTimeStamp()}`;
    }
  },
  mounted() {},
  methods: {
    // 判断是否是移动端
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // 检查常见的移动设备标识符
      return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        userAgent
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/sanliouLinkage/pc/index.vue